export default {
  section: {
    marginBottom: '20px'
  },
  buttonMargin: {
    marginLeft: '10px'
  }
};